module.exports = __webpack_public_path__ + "img/12.60e29c75.jpg";